'use strict'

const SendFilesStream = require('../utils/send-files-stream')
const toPull = require('stream-to-pull-stream')

module.exports = (send) => (options) => toPull(SendFilesStream(send, 'add')(options))



// WEBPACK FOOTER //
// ./node_modules/ipfs-api/src/files/add-pull-stream.js